import Component from '../core/Component';
import throttle from 'lodash/throttle';

export default class _InViewport extends Component {

    constructor(element) {
        super(element)

        this.handleScroll = throttle(this.scroll.bind(this))
    }

    prepare() {
        this.resize()

        window.addEventListener('scroll', this.handleScroll, { passive: true })
        window.addEventListener('resize', this.handleResize)

        this.setRender()
    }

    destroy() {
        window.removeEventListener('scroll', this.handleScroll, { passive: true })
        window.removeEventListener('resize', this.handleResize)
    }

    render(percent) {
        console.warn(percent, " - Method meant to be rewritten.")
    }

    setRender() {
        // only here to be redefined
    }

    handleResize = () => {
        this.resize()
    }

    scroll() {
        if (this.top < this.windowHeight + window.scrollY && this.bottom > window.scrollY) {
            this.render(this.getPercent());
        }
    }

    getPercent() {
        let percentTop = Math.round( 100 - (((this.bottom - (this.windowHeight + window.scrollY)) / this.height)*100) ) / 100;
        let percentBottom = Math.round( (((this.bottom - window.scrollY) / this.height)*100) ) / 100;
        let percent = Math.min(percentTop, percentBottom);
        return percent <= 1 ? percent : 1;
    }

    resize() {
        let body = document.body, html = document.documentElement;
        this.documentHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        this.rect = this.element.getBoundingClientRect();
        this.top = this.rect.y + window.scrollY;
        this.height = this.element.offsetHeight;
        this.bottom = this.top + this.height;
        this.windowHeight = parseInt(window.innerHeight);
    }
}